export default {
    appData(){
        return this.$store.state.globalModule.appData;
    },
    user(){
        return this.$store.state.userModule.user;
    },
    platform(){
        return process.env.VUE_APP_PLATFORM;
    },
    isProduction(){
        return process.env.NODE_ENV === "production";
    },
    capRunning(){
        return this.platform !== 'web';
    },
    webPhone(){
        return this.platform === 'web' && this.phoneOnly;
    },
    miniDerasaPlatform(){
        const mini = process.env.VUE_APP_MINI_DERASATECH_PLATFORM;
        return mini === 'true' || mini === true;
    },
    appLoadedOnce(){
        return this.$store.state.loaded;
    },
    innerApp(){
        return this.isAuthed && this.$route.meta.requiresAuth && this.$route.name !== 'confirm';
    },
    pcOnly(){
        return this.$vuetify.breakpoint.mdAndUp;
    },
    mdAndUp(){
        return this.$vuetify.breakpoint.smAndUp;
    },
    phoneOnly(){
        return !this.pcOnly;
    },
    phoneAndTablet(){
        return this.$vuetify.breakpoint.mdAndDown;
    },
    isAuthed(){
        return !!this.$store.state.userModule.user;
    },
    isAdmin(){
        return this.user ? this.user.groupId == 1 : false;
    },
    isLeader(){
        return this.user ? this.user.groupId == 2 : false;
    }
}